import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { lower } from "change-case";
import { Form, reduxForm, getFormValues, SubmissionError } from "redux-form";
import { Field } from "redux-form";
import { Button, Icon, Breadcrumb, Confirm } from "semantic-ui-react";
import FieldInput, { InputType as type } from "components/SemanticForm";
import { scrollToFirstValidateFailElement } from "core/utilities";
import { validations, validateCase as vCase } from "core/validate";
import { SearchRoleContainer, DataListCont } from "./styled";
import { getHrmsMembers, getRoleByUser, clearSearchRoleK2 } from "ducks/member";
import { MainBodyContent, TablePagination } from "components";
import { supportForUserPath, roleMainSupportForUserPath } from "routes";
import ReactTable from "react-table";
import { columns } from "./AttributeData";

const SearchRoleByUsername = (props) => {
  const { members, memberLoading, reset, history, roleByUser } = props;
  const userPageSize = parseInt(localStorage.getItem("userPageSize") || "10");

  useEffect(() => {
    if (!members.length) {
      props.getHrmsMembers();
    }
    return () => {
      props.clearSearchRoleK2();
    };
  }, []);

  const memberOptions = members.map((m) => ({
    value: lower(m.username),
    text: `${m.firstnameEn} ${m.lastnameEn}`,
  }));

  function callApiSearch() {
    props.getRoleByUser(props.valueForm.username, reset);
  }

  return (
    <MainBodyContent
      headerTitle="Search Role K2 By Username"
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "Support",
              content: "Support",
              link: true,
              onClick: () => {
                history.push(supportForUserPath);
              },
            },
            {
              key: "role",
              content: "Role K2",
              link: true,
              onClick: () => {
                history.push(roleMainSupportForUserPath);
              },
            },
            {
              key: "searchrole",
              content: "Search Role K2 By Username",
              active: true,
            },
          ]}
        />
      }
    >
      <SearchRoleContainer>
        <Form>
          <div className="rowFields">
            <Field
              name="username"
              label="UserName"
              loading={memberLoading}
              options={memberOptions}
              type={type.select}
              component={FieldInput}
              require
              className={"halfRow"}
            />
            <div className="btnContainer" style={{ alignContent: "center" }}>
              <Button
                type="button"
                content="Search"
                color="blue"
                icon="paper plane outline"
                labelPosition="right"
                style={{ marginRight: "5px" }}
                onClick={() => callApiSearch()} //call api search
              />
            </div>
          </div>
        </Form>
        <DataListCont>
          <ReactTable
            data={Object.keys(roleByUser).length > 0 ? roleByUser.data : []}
            columns={columns}
            defaultPageSize={userPageSize}
            noDataText="No Data found"
            previousText={<Icon name="arrow alternate circle left" />}
            nextText={<Icon name="arrow alternate circle right" />}
            className="-striped -highlight"
          />
        </DataListCont>
      </SearchRoleContainer>
    </MainBodyContent>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authen.user,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    roleByUser: state.member.roleByUser,
    valueForm: getFormValues("SearchRoleByUsernameForm")(state) || {},
  };
};

const mapDispatchToProps = {
  getHrmsMembers,
  getRoleByUser,
  clearSearchRoleK2
};

const validate = (values) => {
  let errors = {};
  validations(values, "username", [vCase.require], errors);

  return errors;
};

const SearchRoleByUsernameForm = reduxForm({
  form: "SearchRoleByUsernameForm",
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(SearchRoleByUsername);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchRoleByUsernameForm);
